import Vue from 'vue'

Vue.filter('truncate', (value, length) => {
  if (typeof value !== 'string') {
    return value
  }
  value = value.replace(/(\r\n|\n|\r)/gm, '');
  if (value.length <= length) {
    return value
  }
  return value.substring(0, length) + '...'
})

Vue.filter('numberFormat', (value) => {
  return value.toLocaleString()
})

Vue.filter('percentageFormat', (value) => {
  if (value === 0) {
    return ''
  }
  let percent
  percent = value * 1000
  percent = Math.round(percent)
  percent /= 10
  percent += '%'
  return percent
})

Vue.filter('tagCategory', (value) => {
  const sections = value.split('>')
  for (let i = 0; i < sections.length; i++) {
      let words = sections[i].split('、')
      words = words.map((word) => {
        if (word !== '-') {
          return `<span class="category">${word}</span>`
        } else {
          return word
        }
      })
      sections[i] = words.join('、')
  }
  const result = sections.join('>');
  return result
})

Vue.filter('tagKeyword', (value) => {
  let words = value.split(' ')
  words = words.map((word) => {
      return `<span class="keyword">${word}</span>`
  })
  const searchWords = encodeURIComponent(value)
  const result = words.join(' ') + `<a class="ys-link" href="https://shopping.yahoo.co.jp/search?p=${searchWords}" target="_blank"><i class="fas fa-external-link-alt"></i></a>`
  return result
})